/**
 * Sort methods for the keyvalue pipe
 */

import { KeyValue } from '@angular/common';

/**
 * prevents keyvalue pipe from sorting properties, maintaining the order of the original object / enum
 * usage:
 *   {{ someEnum | keyvalue:originalOrder }}
 */
export const originalOrder = (_a: any, _b: any) => 0;
